<template>
    <div>
        <div class="vx-row mt-3 flex justify-end">
			<div class="vx-col mt-2">
				<RouterLink :to="'/author/' + $route.params.id">
					<vs-button color="dark" type="border">{{ $t('goBack') }}</vs-button>
				</RouterLink>
			</div>
		</div>
		<div class="vx-row w-full">
			<div 
                v-for="(tr, indextr) in listPoint"
                class="vx-col lg:w-1/2 w-full"
            >
                <vs-button
                    @click="$router.push('/author/'+$route.params.id+'/tariff/' + tr.websitePoint)"
                    class="mr-5 mt-10 edit-btn"
                    icon-pack="feather"
                    icon="edit"
                >
                    <feather-icon icon="EditIcon"></feather-icon>&nbsp;{{$t(tr.domain)}}
                </vs-button>
            </div>
        </div>
        <div class="vx-row mt-3 flex justify-end">
			<div class="vx-col mt-2">
				<RouterLink :to="'/author/' + $route.params.id">
					<vs-button color="dark" type="border">{{ $t('goBack') }}</vs-button>
				</RouterLink>
			</div>
		</div>
    </div>
</template>

<script>
    import notifier from "@/mixins/notifier";
    import databaseManager from "@/mixins/databaseManager";

    export default {
        name: "TariffPoint",
        mixins: [databaseManager, notifier],
        data() {
            return {
                listPoint: [],
            }
        },
        async mounted() {
            try {
                this.listPoint = await this.dbGetAuthorCostListPoint(this.$route.params.id);
            } catch (e) {
			    console.log(e);
		    }        
        },
    }
</script>

<style lang="scss">

</style>